/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'

import { paginateParticipants, QueryInfo } from './participantsPaginate'
import { FormParticipant, Participant as ParticipantApi } from '../API'
import {
  formParticipantsByFormEventId,
  participantsByEventId,
} from '../api/queries'

type Participant = Omit<Exclude<ParticipantApi, null>, '__typename'>

export const listParticipantsByEvent = async ({
  eventId = '',
  isFree = false,
  isFormParticipant = false,
  startTimestamp = '',
}) => {
  const queryInfo: QueryInfo = {
    queryName: isFormParticipant
      ? 'formParticipantsByFormEventId'
      : 'participantsByEventId',
    query: isFormParticipant
      ? formParticipantsByFormEventId
      : participantsByEventId,
    variables: isFormParticipant
      ? { formEventId: eventId }
      : { eventId, ...(!isFree && { filter: { orderId: { attributeExists: true } } }) },
    isFormParticipant,
  }

  return paginateParticipants({ queryInfo, isFree, startTimestamp })
}

export const useListParticipantsByEvent = ({
  eventId = '',
  isFree = false,
  isFormParticipant = false,
  startTimestamp = '',
}) => {
  const [participants, setParticipants] = useState<Participant[] | FormParticipant[]>([])
  const [formParticipantTshirtTotal, setFormParticipantTshirtTotal] = useState(null)
  const [loading, setLoading] = useState(false)
  const error = null

  useEffect(() => {
    let didCancel = false

    const fetchData = async () => {
      if (didCancel) return
      setLoading(true)

      if (eventId) {
        const results = await listParticipantsByEvent({
          eventId,
          isFree,
          isFormParticipant,
          startTimestamp,
        })
        if (!didCancel) {
          setParticipants(results.participants)
          setFormParticipantTshirtTotal(results.shirtTotal)
          setLoading(false)
        }
      }
    }

    fetchData()
    return () => { didCancel = true }
  }, [eventId, startTimestamp])

  return { participants, formParticipantTshirtTotal, apiLoading: loading, apiError: error }
}
